import React from 'react';
import { 
  FaShareSquare, FaUsers, FaFileAlt, 
  FaFileInvoiceDollar, FaClipboardList, FaInbox 
} from 'react-icons/fa';
import './WhatsAppBusiness.css';

const WhatsAppBusiness = () => {
  return (
    <div className="whatsapp-page-wrapper">
      {/* ── Hero Section ── */}
      <header className="whatsapp-hero">
        <div className="whatsapp-hero-main">
          <div className="whatsapp-hero-content">
            <h1>WhatsApp for Business</h1>
            <p>
              Make WhatsApp work for your business. Seamlessly integrate TallyPrime 
              into your communication workflow to share documents, collect payments, 
              and manage customer relationships.
            </p>
          </div>
          <div className="whatsapp-hero-visual">
            <img src="/images/wa.webp" alt="WhatsApp Business Visual" className="wa-hero-img" />
          </div>
        </div>
      </header>

      {/* ── Narrative Feature Sections ── */}
      <section className="whatsapp-features-container">
        <FeatureRow 
          icon={<FaShareSquare />}
          title="Instant Document Sharing"
          text="Share invoices, orders, and reports with a single click. Elevate your business efficiency by delivering critical documents directly to your customers' preferred communication channel."
        />
        <FeatureRow 
          icon={<FaFileInvoiceDollar />}
          title="Simplified Payments"
          text="Transform sharing into collection. Embed payment links and QR codes directly into your invoices, facilitating a frictionless payment experience for your clients via WhatsApp."
        />
      </section>

      {/* ── Secondary Grid ── */}
      <section className="whatsapp-grid-section">
        <div className="grid-intro">
          <h2>Advanced Connectivity</h2>
        </div>
        <div className="whatsapp-card-grid">
          <FeatureCard 
            icon={<FaUsers />}
            title="Bulk Communication"
            text="Efficiently manage and share multiple documents or communicate with your entire customer base simultaneously."
          />
          <FeatureCard 
            icon={<FaFileAlt />}
            title="Multi-Format Support"
            text="Flexibility at your fingertips. Share your business documents in PDF, JPEG, or Excel formats based on your needs."
          />
          <FeatureCard 
            icon={<FaClipboardList />}
            title="Ready Templates"
            text="Streamline your messaging with a variety of pre-defined, approved templates for fast and personalized outreach."
          />
          <FeatureCard 
            icon={<FaInbox />}
            title="Dedicated Inbox"
            text="Stay organized with a centralized hub for all incoming customer messages, ensuring no inquiry goes unanswered."
          />
        </div>
      </section>
    </div>
  );
};

const FeatureRow = ({ icon, title, text }) => {
  return (
    <div className="whatsapp-feature-row">
      <div className="whatsapp-feature-text">
        <h2>{title}</h2>
        <p>{text}</p>
      </div>
      <div className="whatsapp-feature-visual">
        <div className="visual-box">
          <div className="icon-circle">
            {icon}
          </div>
          <p style={{fontStyle: 'italic', color: 'var(--text-muted)'}}>
            "Integration designed for modern enterprise workflows."
          </p>
        </div>
      </div>
    </div>
  );
};

const FeatureCard = ({ icon, title, text }) => {
  return (
    <div className="wa-card">
      <div className="wa-card-icon">{icon}</div>
      <h3>{title}</h3>
      <p>{text}</p>
    </div>
  );
};

export default WhatsAppBusiness;
